import { createFileRoute } from '@tanstack/react-router';

import { OperationsTab } from '@/features/deals';

export const Route = createFileRoute('/_app/deals/$dealId/operations')({
  component: function Tab() {
    const { dealId } = Route.useParams();
    return <OperationsTab dealId={dealId} />;
  },
});
